<template>
  <v-avatar
    rounded
    color="white"
    variant="elevated"
    :class="{
      'pa-2': size === 'default',
      'pa-1': size === 'small',
    }"
    :style="{ padding: size === 'x-small' ? '0.15rem' : undefined }"
    :size="size"
  >
    <organization-file-image
      v-if="organization?._id || organizationId"
      :organization-id="organization?._id ?? organizationId!"
      :default-icon="organizationIcon"
      :size="size"
      file-type="icon"
      width="32px"
      :rounded="rounded"
      height="32px"
    />
    <v-icon v-else :size="size">{{ organizationIcon }}</v-icon>
  </v-avatar>
</template>

<script setup lang="ts">
const {
  organization = null,
  organizationId = null,
  size = "default",
  rounded = undefined,
} = defineProps<{
  organization?: Pick<Organization, "_id" | "icon" | "type"> | null
  organizationId?: string | null
  size?: "default" | "small" | "x-small"
  rounded?: string | number | boolean
}>()

const organizationIcon = computed(() => {
  if (!organization) {
    return "help_center"
  }

  return getOrganizationIconByType(organization.type)
})
</script>
